import { Link } from 'react-router-dom';
import React, { useContext, useState, useEffect } from 'react';
import styles from './styles.module.css';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import InventoryIcon from '@mui/icons-material/Inventory';
import PeopleIcon from '@mui/icons-material/People';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DevicesIcon from '@mui/icons-material/Devices';
import { Grid, Button, } from '@mui/material';
import { USER_PERMISSIONS, ROUTES } from 'const';
import { ShopContext } from 'Context/ShopContext';
import { UserContext } from 'Context/UserContext';
import { selectedTabContext } from 'Context/SelectedTabContext';
import ShopsHelper from 'helpers/ShopsHelper';
import ReceiptIcon from '@mui/icons-material/Receipt';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import LayersIcon from '@mui/icons-material/Layers';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import CategoryIcon from '@mui/icons-material/Category';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import GroupsIcon from '@mui/icons-material/Groups';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Divider from '@mui/material/Divider';
import SoupKitchenIcon from '@mui/icons-material/SoupKitchen';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import { useTranslation } from 'react-i18next';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import PlanPrice from 'components/popups/PlanPrice';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FeedbackIcon from '@mui/icons-material/Feedback';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function NavBar() {
  const { t } = useTranslation('common');

  const { selectedTab, setSelectedTab, sections, setSections, selectedSubTab, setSelectedSubTab, setMenuOpen } =
    useContext(selectedTabContext);
  const { user } = useContext(UserContext);
  const { shop, shops } = useContext(ShopContext);

  const hasChain = !!shop?.chain;
  const hasWarehouseValidity = ShopsHelper.isWarehouseFeatureActive(shop);

  useEffect(() => {
    if (selectedTab === 'stock-transfer') {
      setSections((prev) => {
        if (!prev.operations || !prev.stockTransfer) {
          return {
            ...prev,
            operations: true,
            stockTransfer: true,
          };
        }
        return prev;
      });
    }
  }, [selectedTab, setSections]);
  const isMobile = useMediaQuery('(max-width: 1016px)');

  const [showPlanPrice, setShowPlanPrice] = useState(false);

  const openUpgradeModal = () => {
    setShowPlanPrice(true);
  };

  const handleClosePlanPrice = () => {
    setShowPlanPrice(false);
  };

  const tabStyle = {
    color: '#fff',
  };

  const handleSelectedTabChange = (tab) => {
    setSelectedTab(tab);
    setSelectedSubTab(null);
    setMenuOpen(false);
  };

  const handleChangeSections = (tab) => {
    const mainTabs = ['reports', 'operations', 'accounts', 'stockTransfer','management'];

    setSections((prev) => {
      const newState = { ...prev };
      if (mainTabs.includes(tab)) {
        mainTabs.forEach(selectedTab => {
          if (selectedTab !== tab) {
            newState[selectedTab] = false;
          }
        });
      }
      newState[tab] = !prev[tab];
      return newState;
    });

    if (tab === 'dashboard' && shops?.length <= 1) {
      setMenuOpen(false);
    }
  };

  const handleLinkClick = (route) => {
    setSelectedSubTab(route);
    setSelectedTab('');
    setMenuOpen(false);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {isMobile && (
          <IconButton
            onClick={() => setMenuOpen(false)}
            size="small"
            style={{
              backgroundColor: 'rgba(255,255,255,0.12)',
              color: '#fff',
              width: 36,
              height: 36,
              transition: 'all 0.2s ease',
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </div>
        {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
          ''
        ) : shops && shops.length > 1 ? (
          <>
            <div className={`${styles.sectionHeading} ${styles.sectionHeadingTop}`}>{t('All branches')}</div>
            <Link
              to={ROUTES.MULTI_SHOP_DASHBOARD}
              style={{ textDecorationColor: 'transparent' }}
              onClick={() => handleLinkClick(ROUTES.MULTI_SHOP_DASHBOARD)}
            >
              <div
                className={`${styles.navSectionItem} ${styles.mt - 1}`}
                style={
                  selectedSubTab === ROUTES.MULTI_SHOP_DASHBOARD
                    ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                    : {}
                }
              >
                <span className={styles.title}>{t('Dashboard')}</span>
              </div>
            </Link>

            <Divider
              sx={{
                backgroundImage: 'linear-gradient(to right, transparent, rgba(255, 255, 255, 0.2), transparent)',
                height: '1px',
                border: 'none',
                marginTop: '16px',
                marginBottom: '16px',
              }}
            />

            <div className={styles.sectionHeading}>
              {shop?.shop_name} ({shop?.id})
            </div>
            <Link
              to={ROUTES.SINGLE_SHOP_DASHBOARD}
              style={{ textDecorationColor: 'transparent' }}
              onClick={() => handleLinkClick(ROUTES.SINGLE_SHOP_DASHBOARD)}
            >
              <div
                className={`${styles.navSectionItem} ${styles.mt - 1}`}
                style={
                  selectedSubTab === ROUTES.SINGLE_SHOP_DASHBOARD
                    ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                    : {}
                }
              >
                <span className={styles.title}>{t('Dashboard')}</span>
              </div>
            </Link>
          </>
        ) : (
          <Link
            to={ROUTES.SINGLE_SHOP_DASHBOARD}
            style={{ textDecorationColor: 'transparent' }}
            onClick={() => handleLinkClick(ROUTES.SINGLE_SHOP_DASHBOARD)}
          >
            <div
              className={`${styles.navSectionItem} ${styles.mt - 1}`}
              style={
                selectedSubTab === ROUTES.SINGLE_SHOP_DASHBOARD
                  ? { backgroundColor: '#5C62A8', borderRadius: '10px', marginTop: '10px' }
                  : { marginTop: '10px' }
              }
            >
              <span className={styles.title}>{t('Dashboard')}</span>
            </div>
          </Link>
        )}

        <Divider
          sx={{
            backgroundImage: 'linear-gradient(to right, transparent, rgba(255, 255, 255, 0.6), transparent)',
            height: '1px',
            border: 'none',
          }}
        />

        <div
          className={`${styles.navSectionItem} ${styles.mt - 1}`}
          onClick={() => {
            handleChangeSections('reports');
          }}
        >
          <span className={styles.title}>{t('Reports')}</span>
          {sections.reports ? <RemoveIcon className={styles.icons} /> : <AddIcon className={styles.icons} />}
        </div>
        {sections?.reports && (
          <>
            {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
              ''
            ) : (
              <div
                className={`${styles.navItem} ${styles.mt - 1}`}
                style={{
                  ...tabStyle,
                  ...(selectedTab === 'salesTab' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                }}
                onClick={() => {
                  setSections((prev) => ({
                    ...prev,
                    purchaseTab: false,
                    taxTab: false,
                    stockTab: false,
                    salesTab: !prev.salesTab,
                    customerTab: false,
                    ncTab: false,
                    accountLedgerTab: false,
                  }));
                  setSelectedSubTab(null);
                  setSelectedTab('salesTab');
                }}
              >
                <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                  <AssignmentIcon fontSize="small" className={styles.navBarIconColor} />
                </span>
                <span className={styles.title}>{t('Sales Reports')}</span>
                <span className={styles.icons}>
                  {sections.salesTab ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </span>
              </div>
            )}
            {sections.salesTab && (
              <div className={styles.subMenuContainer}>
                <div className={styles.subMenuItems}>
                  <div>
                    <div
                      className={styles.navBarStepper}
                      style={{
                        height: !ShopsHelper.isBasicPlan(shop) ? '570px' : '382px',
                        borderBottom: 'none',
                        borderBottomLeftRadius: '0',
                      }}
                    ></div>
                    <div className={styles.navBarStepper}></div>
                    <div>
                      <Link
                        to={ROUTES.BILL_SUMMARY}
                        style={{ textDecorationColor: 'transparent' }}
                        onClick={() => handleLinkClick(ROUTES.BILL_SUMMARY)}
                      >
                        <div
                          className={styles.subMenu}
                          style={
                            selectedSubTab === ROUTES.BILL_SUMMARY
                              ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                              : {}
                          }
                        >
                          <span>{t('Sales Summary')}</span>
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.ITEM_SUMMARY}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.ITEM_SUMMARY)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.ITEM_SUMMARY
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Item Summary')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.ITEMISED_BILL}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.ITEMISED_BILL)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.ITEMISED_BILL
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Sales Items')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.DAY_WISE_REPORT}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.DAY_WISE_REPORT)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.DAY_WISE_REPORT
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Day Wise')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.STAFF_SALES_REPORT}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.STAFF_SALES_REPORT)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.STAFF_SALES_REPORT
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Staff Sales')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.STAFF_PRODUCT_SALES_REPORT}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.STAFF_PRODUCT_SALES_REPORT)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.STAFF_PRODUCT_SALES_REPORT
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Staff Product Sales')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.CATEGORY_SALES_REPORT}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.CATEGORY_SALES_REPORT)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.CATEGORY_SALES_REPORT
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Category Sales')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.ORDER_TYPE_SALES_REPORT}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.ORDER_TYPE_SALES_REPORT)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.ORDER_TYPE_SALES_REPORT
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Order Type')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.RETURNED_BILL_SUMMARY}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.RETURNED_BILL_SUMMARY)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.RETURNED_BILL_SUMMARY
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Returned Sales Summary')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.RETURNED_ITEM_SUMMARY}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.RETURNED_ITEM_SUMMARY)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.RETURNED_ITEM_SUMMARY
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Returned Item Summary')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.RETURNED_SALE_ITEM_SUMMARY}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.RETURNED_SALE_ITEM_SUMMARY)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.RETURNED_SALE_ITEM_SUMMARY
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Returned Sale Items')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.PAYMENT_MODE_REPORT}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.PAYMENT_MODE_REPORT)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.PAYMENT_MODE_REPORT
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Payments Summary')}</span>
                      </div>
                    </Link>
                  </div>
                  <div>
                    <div className={styles.navBarStepper}></div>
                    <Link
                      to={ROUTES.SERVICE_STAFF_REPORT}
                      style={{ textDecorationColor: 'transparent' }}
                      onClick={() => handleLinkClick(ROUTES.SERVICE_STAFF_REPORT)}
                    >
                      <div
                        className={styles.subMenu}
                        style={
                          selectedSubTab === ROUTES.SERVICE_STAFF_REPORT
                            ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                            : {}
                        }
                      >
                        <span>{t('Service Staff Summary')}</span>
                      </div>
                    </Link>
                  </div>
                  {!ShopsHelper.isBasicPlan(shop) && (
                    <>
                      <div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.PROFIT_BILL_SUMMARY}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={(e) => {
                            if (!ShopsHelper.hasPremiumAccess(shop)) {
                              e.preventDefault();
                              openUpgradeModal();
                            } else {
                              handleLinkClick(ROUTES.PROFIT_BILL_SUMMARY);
                            }
                          }}
                        >
                          <div
                            className={`${styles.subMenu} ${
                              !ShopsHelper.hasPremiumAccess(shop) && styles.subMenuSmall
                            }`}
                            style={
                              selectedSubTab === ROUTES.PROFIT_BILL_SUMMARY
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span className={!ShopsHelper.hasPremiumAccess(shop) ? styles.subButtonContainer : ''}>
                              <span className={styles.subButtonText}>{t('Profit Sales Summary')}</span>
                              {!ShopsHelper.hasPremiumAccess(shop) && (
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={(e) => {
                                    e.preventDefault(); // prevent Link navigation
                                    e.stopPropagation(); // prevent parent click
                                    openUpgradeModal();
                                  }}
                                  className={styles.upgradeButton}
                                >
                                  Upgrade
                                </Button>
                              )}
                            </span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.PROFIT_ITEM_SUMMARY}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={(e) => {
                            if (!ShopsHelper.hasPremiumAccess(shop)) {
                              e.preventDefault();
                              openUpgradeModal();
                            } else {
                              handleLinkClick(ROUTES.PROFIT_ITEM_SUMMARY);
                            }
                          }}
                        >
                          <div
                            className={`${styles.subMenu} ${
                              !ShopsHelper.hasPremiumAccess(shop) && styles.subMenuSmall
                            }`}
                            style={
                              selectedSubTab === ROUTES.PROFIT_ITEM_SUMMARY
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span className={!ShopsHelper.hasPremiumAccess(shop) ? styles.subButtonContainer : ''}>
                              <span className={styles.subButtonText}>{t('Profit Item Summary')}</span>
                              {!ShopsHelper.hasPremiumAccess(shop) && (
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openUpgradeModal();
                                  }}
                                  className={styles.upgradeButton}
                                >
                                  Upgrade
                                </Button>
                              )}
                            </span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.PROFIT_ITEMISED_BILL}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={(e) => {
                            if (!ShopsHelper.hasPremiumAccess(shop)) {
                              e.preventDefault();
                              openUpgradeModal();
                            } else {
                              handleLinkClick(ROUTES.PROFIT_ITEMISED_BILL);
                            }
                          }}
                        >
                          <div
                            className={`${styles.subMenu} ${
                              !ShopsHelper.hasPremiumAccess(shop) && styles.subMenuSmall
                            }`}
                            style={
                              selectedSubTab === ROUTES.PROFIT_ITEMISED_BILL
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span className={!ShopsHelper.hasPremiumAccess(shop) ? styles.subButtonContainer : ''}>
                              <span className={styles.subButtonText}>{t('Profit Sales Items')}</span>
                              {!ShopsHelper.hasPremiumAccess(shop) && (
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openUpgradeModal();
                                  }}
                                  className={styles.upgradeButton}
                                >
                                  Upgrade
                                </Button>
                              )}
                            </span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.PROFIT_DAY_WISE_REPORT}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={(e) => {
                            if (!ShopsHelper.hasPremiumAccess(shop)) {
                              e.preventDefault();
                              openUpgradeModal();
                            } else {
                              handleLinkClick(ROUTES.PROFIT_DAY_WISE_REPORT);
                            }
                          }}
                        >
                          <div
                            className={`${styles.subMenu} ${
                              !ShopsHelper.hasPremiumAccess(shop) && styles.subMenuSmall
                            }`}
                            style={
                              selectedSubTab === ROUTES.PROFIT_DAY_WISE_REPORT
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span className={!ShopsHelper.hasPremiumAccess(shop) ? styles.subButtonContainer : ''}>
                              <span className={styles.subButtonText}>{t('Profit Day Wise')}</span>
                              {!ShopsHelper.hasPremiumAccess(shop) && (
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openUpgradeModal();
                                  }}
                                  className={styles.upgradeButton}
                                >
                                  Upgrade
                                </Button>
                              )}
                            </span>
                          </div>
                        </Link>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
            {!ShopsHelper.isBasicPlan(shop) && (
              <>
                {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <div
                    className={`${styles.navItem} ${styles.mt - 1}`}
                    style={{
                      ...tabStyle,
                      ...(selectedTab === 'purchaseTab' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                    }}
                    onClick={(e) => {
                      if (ShopsHelper.isFreePlan(shop)) {
                        e.preventDefault();
                        openUpgradeModal();
                        return;
                      }
                      setSections((prev) => ({
                        ...prev,
                        salesTab: false,
                        stockTab: false,
                        purchaseTab: !prev.purchaseTab,
                        taxTab: false,
                        customerTab: false,
                        ncTab: false,
                        accountLedgerTab: false,
                      }));
                      setSelectedSubTab(null);
                      setSelectedTab('purchaseTab');
                    }}
                  >
                    <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                      <WysiwygIcon fontSize="small" className={styles.navBarIconColor} />
                    </span>
                    <span className={ShopsHelper.isFreePlan(shop) ? styles.buttonContainer : styles.title}>
                      <span className={styles.buttonText}>{t('Purchase Reports')}</span>
                      {ShopsHelper.isFreePlan(shop) && (
                        <Button
                          size="small"
                          variant="contained"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openUpgradeModal();
                          }}
                          className={styles.upgradeButton}
                        >
                          Upgrade
                        </Button>
                      )}
                    </span>
                    {!ShopsHelper.isFreePlan(shop) && (
                      <span className={styles.icons}>
                        {sections.purchaseTab ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </span>
                    )}
                  </div>
                )}
                {sections.purchaseTab && (
                  <div className={styles.subMenuContainer}>
                    <div className={styles.subMenuItems}>
                      <div>
                        <div className={styles.navBarStepper} style={{ height: '86px' }}></div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.PURCHASE_SUMMARY}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.PURCHASE_SUMMARY)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.PURCHASE_SUMMARY
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Purchase Summary')}</span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.PURCHASE_ITEM_SUMMARY}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.PURCHASE_ITEM_SUMMARY)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.PURCHASE_ITEM_SUMMARY
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Purchase Items')}</span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <Link
                          to={ROUTES.VENDON_PURCHASE_SUMMARY}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.VENDON_PURCHASE_SUMMARY)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.VENDON_PURCHASE_SUMMARY
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Vendor Purchase')}</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            {shop && !ShopsHelper.isBasicPlan(shop) && (
              <>
                {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <div
                    className={`${styles.navItem} ${styles.mt - 1}`}
                    style={{
                      ...tabStyle,
                      ...(selectedTab === 'customerTab' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                    }}
                    onClick={(e) => {
                      if (ShopsHelper.isFreePlan(shop)) {
                        e.preventDefault();
                        openUpgradeModal();
                        return;
                      }
                      setSections((prev) => ({
                        ...prev,
                        salesTab: false,
                        stockTab: false,
                        purchaseTab: false,
                        customerTab: !prev.customerTab,
                        taxTab: false,
                        ncTab: false,
                        accountLedgerTab: false,
                      }));
                      setSelectedSubTab(null);
                      setSelectedTab('customerTab');
                    }}
                  >
                    <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                      <PeopleIcon fontSize="small" className={styles.navBarIconColor} />
                    </span>
                    <span className={ShopsHelper.isFreePlan(shop) ? styles.buttonContainer : styles.title}>
                      <span className={styles.buttonText}>{t('Customer Report')}</span>
                      {ShopsHelper.isFreePlan(shop) && (
                        <Button
                          size="small"
                          variant="contained"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openUpgradeModal();
                          }}
                          className={styles.upgradeButton}
                        >
                          Upgrade
                        </Button>
                      )}
                    </span>
                    {!ShopsHelper.isFreePlan(shop) && (
                      <span className={styles.icons}>
                        {sections.customerTab ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </span>
                    )}
                  </div>
                )}
                {sections.customerTab && (
                  <div className={styles.subMenuContainer}>
                    <div className={styles.subMenuItems}>
                      <div>
                        <div className={styles.navBarStepper} style={{ height: '50px',borderBottom: 'none',borderBottomLeftRadius: '0'}}></div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.CUSTOMER_OUTSTANDING_REPORT}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.CUSTOMER_OUTSTANDING_REPORT)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.CUSTOMER_OUTSTANDING_REPORT
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Outstanding Summary')}</span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.CUSTOMER_PAYMENT_REPORT}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.CUSTOMER_PAYMENT_REPORT)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.CUSTOMER_PAYMENT_REPORT
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Customer Payment')}</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            {shop && !ShopsHelper.isFreePlan(shop) && (
              <>
                {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <div
                    className={`${styles.navItem} ${styles.mt - 1}`}
                    style={{
                      ...tabStyle,
                      ...(selectedTab === 'taxTab' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                    }}
                    onClick={(e) => {
                      if (ShopsHelper.isFreePlan(shop)) {
                        e.preventDefault();
                        openUpgradeModal();
                        return;
                      }
                      setSections((prev) => ({
                        ...prev,
                        salesTab: false,
                        purchaseTab: false,
                        stockTab: false,
                        customerTab: false,
                        taxTab: !prev.taxTab,
                        ncTab: false,
                        accountLedgerTab: false,
                      }));
                      setSelectedSubTab(null);
                      setSelectedTab('taxTab');
                    }}
                  >
                    <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                      <ReceiptIcon fontSize="small" className={styles.navBarIconColor} />
                    </span>
                    <span className={ShopsHelper.isFreePlan(shop) ? styles.buttonContainer : styles.title}>
                      <span className={styles.buttonText}>{t('Tax Reports')}</span>
                      {ShopsHelper.isFreePlan(shop) && (
                        <Button
                          size="small"
                          variant="contained"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openUpgradeModal();
                          }}
                          className={styles.upgradeButton}
                        >
                          Upgrade
                        </Button>
                      )}
                    </span>
                    {!ShopsHelper.isFreePlan(shop) && (
                      <span className={styles.icons}>
                        {sections.taxTab ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </span>
                    )}
                  </div>
                )}
                {sections.taxTab && (
                  <div className={styles.subMenuContainer}>
                    <div className={styles.subMenuItems}>
                      <div>
                        <div className={styles.navBarStepper} style={{ height: '86px' }}></div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.SALES_TAX_SUMMARY}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.SALES_TAX_SUMMARY)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.SALES_TAX_SUMMARY
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Sales Tax Summary')}</span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.PURCHASE_TAX_SUMMARY}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.PURCHASE_TAX_SUMMARY)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.PURCHASE_TAX_SUMMARY
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Purchase Tax Summary')}</span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <Link
                          to={ROUTES.HSN_SUMMARY}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.HSN_SUMMARY)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.HSN_SUMMARY
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('HSN Summary')}</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            {shop && !ShopsHelper.isFreePlan(shop) && (
              <>
                {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <div
                    className={`${styles.navItem} ${styles.mt - 1}`}
                    style={{
                      ...tabStyle,
                      ...(selectedTab === 'stockTab' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                    }}
                    onClick={(e) => {
                      if (ShopsHelper.isFreePlan(shop)) {
                        e.preventDefault();
                        openUpgradeModal();
                        return;
                      }
                      setSections((prev) => ({
                        ...prev,
                        salesTab: false,
                        purchaseTab: false,
                        taxTab: false,
                        stockTab: !prev.stockTab,
                        customerTab: false,
                        ncTab: false,
                        accountLedgerTab: false,
                      }));
                      setSelectedSubTab(null);
                      setSelectedTab('stockTab');
                    }}
                  >
                    <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                      <SyncAltIcon fontSize="small" className={styles.navBarIconColor} />
                    </span>
                    <span className={ShopsHelper.isFreePlan(shop) ? styles.buttonContainer : styles.title}>
                      <span className={styles.buttonText}>{t('Stock Reports')}</span>
                      {ShopsHelper.isFreePlan(shop) && (
                        <Button
                          size="small"
                          variant="contained"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openUpgradeModal();
                          }}
                          className={styles.upgradeButton}
                        >
                          Upgrade
                        </Button>
                      )}
                    </span>
                    {!ShopsHelper.isFreePlan(shop) && (
                      <span className={styles.icons}>
                        {sections.stockTab ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </span>
                    )}
                  </div>
                )}
                {sections.stockTab && (
                  <div className={styles.subMenuContainer}>
                    <div className={styles.subMenuItems}>
                      <div>
                        <div className={styles.navBarStepper} style={{ height: '158px' }}></div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.STOCK_SUMMARY}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.STOCK_SUMMARY)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.STOCK_SUMMARY
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Stock Summary')}</span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.STOCK_CHANGE_REPORT}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.STOCK_CHANGE_REPORT)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.STOCK_CHANGE_REPORT
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Stock Change Summary')}</span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.MANUAL_STOCK_ADJUSTMENT_REPORT}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.MANUAL_STOCK_ADJUSTMENT_REPORT)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.MANUAL_STOCK_ADJUSTMENT_REPORT
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Manual Adjustment')}</span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.ITEM_STOCK_EXPIRING_REPORT}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.ITEM_STOCK_EXPIRING_REPORT)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.ITEM_STOCK_EXPIRING_REPORT
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Expiring Item Stock')}</span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <Link
                          to={ROUTES.ITEM_STOCK_EXPIRED_REPORT}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.ITEM_STOCK_EXPIRED_REPORT)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.ITEM_STOCK_EXPIRED_REPORT
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Expired Item Stock')}</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            {shop && !ShopsHelper.isFreePlan(shop) && (
              <>
                {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <div
                    className={`${styles.navItem} ${styles.mt - 1}`}
                    style={{
                      ...tabStyle,
                      ...(selectedTab === 'ncTab' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                    }}
                    onClick={(e) => {
                      if (ShopsHelper.isFreePlan(shop)) {
                        e.preventDefault();
                        openUpgradeModal();
                      } else {
                        setSections((prev) => ({
                          ...prev,
                          salesTab: false,
                          purchaseTab: false,
                          taxTab: false,
                          stockTab: false,
                          customerTab: false,
                          ncTab: !prev.ncTab,
                          accountLedgerTab: false,
                        }));
                        setSelectedSubTab(null);
                        setSelectedTab('ncTab');
                      }
                    }}
                  >
                    <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                      <MoneyOffIcon fontSize="small" className={styles.navBarIconColor} />
                    </span>
                    <span className={ShopsHelper.isFreePlan(shop) ? styles.buttonContainer : styles.title}>
                      <span className={styles.buttonText}>{t('NC Reports')} </span>
                      {ShopsHelper.isFreePlan(shop) && (
                        <Button
                          size="small"
                          variant="contained"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openUpgradeModal();
                          }}
                          className={styles.upgradeButton}
                        >
                          Upgrade
                        </Button>
                      )}
                    </span>
                    {!ShopsHelper.isFreePlan(shop) && (
                      <span className={styles.icons}>
                        {sections.ncTab ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </span>
                    )}
                  </div>
                )}
                {sections.ncTab && (
                  <div className={styles.subMenuContainer}>
                    <div className={styles.subMenuItems}>
                      <div>
                        <div className={styles.navBarStepper} style={{ height: '50px' }}></div>
                        <div className={styles.navBarStepper}></div>
                        <Link
                          to={ROUTES.NC_SALES_REPORT}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={(e) => {
                            if (ShopsHelper.isFreePlan(shop)) {
                              e.preventDefault();
                              openUpgradeModal();
                            } else {
                              handleLinkClick(ROUTES.NC_SALES_REPORT);
                            }
                          }}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.NC_SALES_REPORT
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Sales Summary')}</span>
                          </div>
                        </Link>
                      </div>
                      <div>
                        <Link
                          to={ROUTES.NC_CUSTOMER_REPORT}
                          style={{ textDecorationColor: 'transparent' }}
                          onClick={() => handleLinkClick(ROUTES.NC_CUSTOMER_REPORT)}
                        >
                          <div
                            className={styles.subMenu}
                            style={
                              selectedSubTab === ROUTES.NC_CUSTOMER_REPORT
                                ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                : {}
                            }
                          >
                            <span>{t('Customer Report')}</span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
                {shop && !ShopsHelper.isFreePlan(shop) && (
                  <>


                    {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
                      ''
                    ) : (
                      <Link to={ROUTES.ALL_PARTY_REPORT} style={{ textDecorationColor: 'transparent' }}>
                        <div
                          className={`${styles.navItem} ${styles.mt - 4}`}
                          style={{
                            ...tabStyle,
                            ...(selectedTab === 'all-party-report' && {
                              backgroundColor: '#5C62A8',
                              borderRadius: '10px',
                            }),
                          }}
                          onClick={(e) => {
                            if (ShopsHelper.isFreePlan(shop)) {
                              e.preventDefault();
                              openUpgradeModal();
                              return;
                            }
                            setSections((prev) => ({
                              ...prev,
                              salesTab: false,
                              purchaseTab: false,
                              stockTab: false,
                              customerTab: false,
                              taxTab: false,
                              ncTab: false,
                            }));
                            handleSelectedTabChange('all-party-report');
                            handleLinkClick(ROUTES.ALL_PARTY_REPORT);
                          }}
                        >
                          <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                            <GroupsIcon fontSize="small" className={styles.navBarIconColor} />
                          </span>
                          <span className={ShopsHelper.isFreePlan(shop) ? styles.buttonContainer : styles.title}>
                            <span>{t('All Party Report')}</span>
                            {ShopsHelper.isFreePlan(shop) && (
                              <Button
                                size="small"
                                variant="contained"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  openUpgradeModal();
                                }}
                                className={styles.upgradeButton}
                              >
                                Upgrade
                              </Button>
                            )}
                          </span>
                        </div>
                      </Link>
                    )}
                  </>
                )}
              </>
            )}

            {shop && !ShopsHelper.isFreePlan(shop) && (
              <>
                {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.SHIFTS} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={`${styles.navItem} ${styles.mt - 4}`}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'shift-report' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={(e) => {
                        if (ShopsHelper.isFreePlan(shop)) {
                          e.preventDefault();
                          openUpgradeModal();
                          return;
                        }

                        setSections((prev) => ({
                          ...prev,
                          salesTab: false,
                          purchaseTab: false,
                          taxTab: false,
                          stockTab: false,
                          customerTab: false,
                          ncTab: false,
                          accountLedgerTab: false,
                        }));
                        handleSelectedTabChange('shift-report');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <ChangeCircleIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={ShopsHelper.isFreePlan(shop) ? styles.buttonContainer : styles.title}>
                        <span className={styles.buttonText}>{t('Shift Reports')} </span>
                        {ShopsHelper.isFreePlan(shop) && (
                          <Button
                            size="small"
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openUpgradeModal();
                            }}
                            className={styles.upgradeButton}
                          >
                            Upgrade
                          </Button>
                        )}
                      </span>
                    </div>
                  </Link>
                )}
                {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.ESTIMATE_REPORT} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={`${styles.navItem} ${styles.mt - 4}`}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'estimate-report' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={(e) => {
                        if (!ShopsHelper.hasPremiumAccess(shop)) {
                          e.preventDefault();
                          openUpgradeModal();
                          return;
                        }

                        setSections((prev) => ({
                          ...prev,
                          salesTab: false,
                          purchaseTab: false,
                          taxTab: false,
                          stockTab: false,
                          customerTab: false,
                          ncTab: false,
                          accountLedgerTab: false,
                        }));
                        handleSelectedTabChange('estimate-report');
                        handleLinkClick(ROUTES.ESTIMATE_REPORT);
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <AssessmentIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={!ShopsHelper.hasPremiumAccess(shop) ? styles.buttonContainer : styles.title}>
                        <span className={styles.buttonText}>{t('Estimate Report')} </span>
                        {!ShopsHelper.hasPremiumAccess(shop) && (
                          <Button
                            size="small"
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openUpgradeModal();
                            }}
                            className={styles.upgradeButton}
                          >
                            Upgrade
                          </Button>
                        )}
                      </span>
                    </div>
                  </Link>
                )}
              </>
            )}
          </>
        )}

        <Divider
          sx={{
            backgroundImage: 'linear-gradient(to right, transparent, rgba(255, 255, 255, 0.6), transparent)',
            height: '1px',
            border: 'none',
          }}
        />

        {!ShopsHelper.isBasicPlan(shop) && (
          <>
            <div
              className={`${styles.navSectionItem} ${styles.mt - 1}`}
              onClick={(e) => {
                if (ShopsHelper.isFreePlan(shop)) {
                  e.preventDefault();
                  openUpgradeModal();
                  return;
                }
                handleChangeSections('operations');
              }}
            >
              {ShopsHelper.isFreePlan(shop) ? (
                <span className={styles.buttonContainer}>
                  <span className={styles.buttonText}>{t('Operations')}</span>
                  <Button
                    size="small"
                    variant="contained"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      openUpgradeModal();
                    }}
                    className={styles.upgradeButton}
                  >
                    Upgrade
                  </Button>
                </span>
              ) : (
                <>
                  <span className={styles.title}>{t('Operations')}</span>
                  {sections.operations ? <RemoveIcon className={styles.icons} /> : <AddIcon className={styles.icons} />}
                </>
              )}
            </div>
            {sections?.operations && (
              <>
                {((user || {}).shop_permissions || {}).purchase_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.PURCHASE_HISTORY} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={styles.navItem}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'purchase-history' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={() => {
                        handleSelectedTabChange('purchase-history');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <ShoppingCartIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={styles.title}>{t('Purchases')}</span>
                    </div>
                  </Link>
                )}
                {((user || {}).shop_permissions || {}).purchase_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.PURCHASE_RETURN_HISTORY} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={styles.navItem}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'purchase-return' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={() => {
                        handleSelectedTabChange('purchase-return');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <RemoveShoppingCartIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={styles.title}>{t('Purchase Returns')}</span>
                    </div>
                  </Link>
                )}
                {((user || {}).shop_permissions || {}).purchase_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.VENDORS} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={styles.navItem}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'vendors' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={() => {
                        handleSelectedTabChange('vendors');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <InventoryIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={styles.title}>{t('Vendors')}</span>
                    </div>
                  </Link>
                )}
                {((user || {}).shop_permissions || {}).expense_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.PRODUCTION_HISTORY} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={styles.navItem}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'production' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={() => {
                        handleSelectedTabChange('production');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <SoupKitchenIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={styles.title}>{t('Production')}</span>
                    </div>
                  </Link>
                )}
                {((user || {}).shop_permissions || {}).expense_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.EXPENSES} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={styles.navItem}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'expenses' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={() => {
                        handleSelectedTabChange('expenses');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <CreditCardIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={styles.title}>{t('Expenses')}</span>
                    </div>
                  </Link>
                )}
                {((user || {}).shop_permissions || {}).damage_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.DAMAGE_HISTORY} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={`${styles.navItem} ${styles.mt - 4}`}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'damage-history' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={() => {
                        handleSelectedTabChange('damage-history');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <AssessmentIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={styles.title}>{t('Stock Damages')}</span>
                    </div>
                  </Link>
                )}

                {((user || {}).shop_permissions || {}).damage_permission !== USER_PERMISSIONS.DENY && (
                  <>
                    {hasChain && hasWarehouseValidity && (
                      <>
                        <div
                          className={styles.navItem}
                          style={{
                            ...tabStyle,
                            ...(selectedTab === 'stock-transfer' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                          }}
                          onClick={() => {
                            setSections((prev) => ({
                              ...prev,
                              stockTransfer: !prev.stockTransfer,
                            }));
                            setSelectedSubTab(null);
                            setSelectedTab('stock-transfer');
                          }}
                        >
                          <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                            <SyncAltIcon fontSize="small" className={styles.navBarIconColor} />
                          </span>
                          <span className={styles.title}>{t('Stock Transfer')}</span>
                          <span className={styles.icons}>
                            {sections.stockTransfer ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </span>
                        </div>
                        {sections.stockTransfer && (
                          <div className={styles.subMenuContainer}>
                            <div className={styles.subMenuItems}>
                              <div>
                                <div
                                  className={styles.navBarStepper}
                                  style={{
                                    height: '46px',
                                    borderBottom: 'none',
                                    borderBottomLeftRadius: '0',
                                  }}
                                ></div>
                                <div className={styles.navBarStepper}></div>
                                <Link
                                  to={ROUTES.INTERNAL_STOCK_TRANSFER}
                                  style={{ textDecorationColor: 'transparent' }}
                                  onClick={() => {
                                    handleSelectedTabChange('stock-transfer');
                                    handleLinkClick(ROUTES.INTERNAL_STOCK_TRANSFER);
                                  }}
                                >
                                  <div
                                    className={styles.subMenu}
                                    style={
                                      selectedSubTab === ROUTES.INTERNAL_STOCK_TRANSFER
                                        ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                        : {}
                                    }
                                  >
                                    <span>{t('Internal')}</span>
                                  </div>
                                </Link>
                              </div>
                              <div>
                                <div className={styles.navBarStepper}></div>
                                <Link
                                  to={ROUTES.STOCK_TRANSFER}
                                  style={{ textDecorationColor: 'transparent' }}
                                  onClick={() => {
                                    handleSelectedTabChange('stock-transfer');
                                    handleLinkClick(ROUTES.STOCK_TRANSFER);
                                  }}
                                >
                                  <div
                                    className={styles.subMenu}
                                    style={
                                      selectedSubTab === ROUTES.STOCK_TRANSFER
                                        ? { backgroundColor: '#5C62A8', borderRadius: '10px' }
                                        : {}
                                    }
                                  >
                                    <span>{t('External')}</span>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {hasChain && !hasWarehouseValidity && (
                      <Link to={ROUTES.STOCK_TRANSFER} style={{ textDecorationColor: 'transparent' }}>
                        <div
                          className={`${styles.navItem} ${styles.mt - 4}`}
                          style={{
                            ...tabStyle,
                            ...(selectedSubTab === ROUTES.STOCK_TRANSFER && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                          }}
                          onClick={() => {
                            handleSelectedTabChange('stock-transfer');
                            handleLinkClick(ROUTES.STOCK_TRANSFER);
                          }}
                        >
                          <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                            <SwapHorizRoundedIcon fontSize="small" className={styles.navBarIconColor} />
                          </span>
                          <span className={styles.title}>{t('External Stock Transfer')}</span>
                        </div>
                      </Link>
                    )}
                    {!hasChain && hasWarehouseValidity && (
                      <Link to={ROUTES.INTERNAL_STOCK_TRANSFER} style={{ textDecorationColor: 'transparent' }}>
                        <div
                          title={t('Warehouse Stock Transfer')}
                          className={`${styles.navItem} ${styles.mt - 4}`}
                          style={{
                            ...tabStyle,
                            ...(selectedSubTab === ROUTES.INTERNAL_STOCK_TRANSFER && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                          }}
                          onClick={() => {
                            handleSelectedTabChange('stock-transfer');
                            handleLinkClick(ROUTES.INTERNAL_STOCK_TRANSFER);
                          }}
                        >
                          <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                            <CompareArrowsIcon fontSize="small" className={styles.navBarIconColor} />
                          </span>
                          <span className={styles.title}>{t('Warehouse Stock Transfer')}</span>
                        </div>
                      </Link>
                    )}
                  </>
                )}

                {ShopsHelper.hasPremiumAccess(shop) && (
                  <>
                    {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
                      ''
                    ) : (
                      <Link to={ROUTES.ORDER_ACTIONS} style={{ textDecorationColor: 'transparent' }}>
                        <div
                          className={styles.navItem}
                          style={{
                            ...tabStyle,
                            ...(selectedTab === 'order-actions' && {
                              backgroundColor: '#5C62A8',
                              borderRadius: '10px',
                            }),
                          }}
                          onClick={() => {
                            handleSelectedTabChange('order-actions');
                          }}
                        >
                          <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                            <LayersIcon fontSize="small" className={styles.navBarIconColor} />
                          </span>
                          <span className={styles.title}>{t('Order Actions')}</span>
                        </div>
                      </Link>
                    )}
                  </>
                )}
                {((user || {}).shop_permissions || {}).products_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.CUSTOMERS} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={styles.navItem}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'customers' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={() => {
                        handleSelectedTabChange('customers');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <PeopleIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={styles.title}>{t('Customers')}</span>
                    </div>
                  </Link>
                )}

                {((user || {}).shop_permissions || {}).purchase_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.CUSTOMER_GROUP} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={styles.navItem}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'customer-group' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={() => {
                        handleSelectedTabChange('customer-group');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <GroupsIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={styles.title}>{t('Customer Groups')}</span>
                    </div>
                  </Link>
                )}
                {((user || {}).shop_permissions || {}).purchase_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.MANAGE_SALES} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={styles.navItem}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'sales-history' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={() => {
                        handleSelectedTabChange('sales-history');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <ShoppingBasketIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={styles.title}>{t('Sales')}</span>
                    </div>
                  </Link>
                )}

                {((user || {}).shop_permissions || {}).purchase_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.ESTIMATES} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={styles.navItem}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'estimates' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={(e) => {
                        if (!ShopsHelper.hasPremiumAccess(shop)) {
                          e.preventDefault();
                          openUpgradeModal();
                          return;
                        }
                        handleSelectedTabChange('estimates');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <RequestQuoteIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={!ShopsHelper.hasPremiumAccess(shop) ? styles.buttonContainer : styles.title}>
                        <span className={styles.buttonText}>{t('Estimates')}</span>
                        {!ShopsHelper.hasPremiumAccess(shop) && (
                          <Button
                            size="small"
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openUpgradeModal();
                            }}
                            className={styles.upgradeButton}
                          >
                            Upgrade
                          </Button>
                        )}
                      </span>
                    </div>
                  </Link>
                )}
                {((user || {}).shop_permissions || {}).shop_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.ONLINE_ORDERS} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={styles.navItem}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'online-orders' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={() => {
                        handleSelectedTabChange('online-orders');
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <BookOnlineIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={styles.title}>{t('Online Orders')}</span>
                    </div>
                  </Link>
                )}
                <Link to={ROUTES.FEEDBACK_MANAGEMENT} style={{ textDecorationColor: 'transparent' }}>
                  <div
                    className={`${styles.navItem} ${styles.mt - 4}`}
                    style={{
                      ...tabStyle,
                      ...(selectedTab === 'feedback' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                    }}
                    onClick={(e) => {
                      if (!ShopsHelper.hasPremiumAccess(shop)) {
                        e.preventDefault();
                        e.stopPropagation();
                        openUpgradeModal();
                        return;
                      }
                      handleSelectedTabChange('feedback');
                    }}
                  >
                    <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                      <FeedbackIcon fontSize="small" className={styles.navBarIconColor} />
                    </span>
                    <span className={!ShopsHelper.hasPremiumAccess(shop) ? styles.buttonContainer : styles.title}>
                      <span className={styles.buttonText}>{t('Feedback')}</span>
                      {!ShopsHelper.hasPremiumAccess(shop) && (
                        <Button
                          size="small"
                          variant="contained"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openUpgradeModal();
                          }}
                          className={styles.upgradeButton}
                        >
                          PRO
                        </Button>
                      )}
                    </span>
                  </div>
                </Link>
              </>
            )}
          </>
        )}

        <Divider
          sx={{
            backgroundImage: 'linear-gradient(to right, transparent, rgba(255, 255, 255, 0.6), transparent)',
            height: '1px',
            border: 'none',
          }}
        />

        <div
          className={`${styles.navSectionItem} ${styles.mt - 1}`}
          onClick={() => {
            handleChangeSections('accounts');
          }}
        >
          <span className={styles.title}>{t('Accounts')}</span>
          {sections.accounts ? <RemoveIcon className={styles.icons} /> : <AddIcon className={styles.icons} />}
        </div>
        {sections?.accounts && (
          <>
            {((user || {}).shop_permissions || {}).devices_permission === USER_PERMISSIONS.DENY ? (
              ''
            ) : (
              <Link to={ROUTES.ACCOUNT_HEADS} style={{ textDecorationColor: 'transparent' }}>
                <div
                  className={`${styles.navItem} ${styles.mt - 4}`}
                  style={{
                    ...tabStyle,
                    ...(selectedTab === 'account-heads' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                  }}
                  onClick={() => {
                    handleSelectedTabChange('account-heads');
                  }}
                >
                  <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                    <AccountBalanceWalletIcon fontSize="small" className={styles.navBarIconColor} />
                  </span>
                  <span className={styles.title}>{t('Heads')}</span>
                </div>
              </Link>
            )}
            {shop && !ShopsHelper.isFreePlan(shop) && (
              <>
                {((user || {}).shop_permissions || {}).reports_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link to={ROUTES.ACCOUNT_LEDGER} style={{ textDecorationColor: 'transparent' }}>
                    <div
                      className={`${styles.navItem} ${styles.mt - 4}`}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'account-ledger' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                      onClick={(e) => {
                        if (ShopsHelper.isFreePlan(shop)) {
                          e.preventDefault();
                          openUpgradeModal();
                          return;
                        }
                        handleSelectedTabChange('account-ledger');
                        handleLinkClick(ROUTES.ACCOUNT_LEDGER);
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <ReceiptLongIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={ShopsHelper.isFreePlan(shop) ? styles.buttonContainer : styles.title}>
                        <span>{t('Ledgers')}</span>
                        {ShopsHelper.isFreePlan(shop) && (
                          <Button
                            size="small"
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openUpgradeModal();
                            }}
                            className={styles.upgradeButton}
                          >
                            Upgrade
                          </Button>
                        )}
                      </span>
                    </div>
                  </Link>
                )}
              </>
            )}
          </>
        )}



        <Divider
          sx={{
            backgroundImage: 'linear-gradient(to right, transparent, rgba(255, 255, 255, 0.6), transparent)',
            height: '1px',
            border: 'none',
          }}
        />

        <div
          className={`${styles.navSectionItem} ${styles.mt - 1}`}
          style={
            {
              // ...(sections?.management ? tabStyleActive : tabStyle),
              // borderBottom: sections?.management ? '1px solid rgb(255, 255, 255)' : 'none',
            }
          }
          onClick={() => {
            handleChangeSections('management');
          }}
        >
          <span className={styles.title}>{t('Management')}</span>
          {sections.management ? <RemoveIcon className={styles.icons} /> : <AddIcon className={styles.icons} />}
        </div>
        {sections?.management && (
          <>
            {((user || {}).shop_permissions || {}).products_permission === USER_PERMISSIONS.DENY ? (
              ''
            ) : (
              <Link to={ROUTES.ITEMS} style={{ textDecorationColor: 'transparent' }}>
                <div
                  className={`${styles.navItem} ${styles.mt - 4}`}
                  style={{
                    ...tabStyle,
                    ...(selectedTab === 'products' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                  }}
                  onClick={() => {
                    handleSelectedTabChange('products');
                  }}
                >
                  <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                    <ShoppingBagIcon fontSize="small" className={styles.navBarIconColor} />
                  </span>
                  <span className={styles.title}>{t('Products')}</span>
                </div>
              </Link>
            )}
            {((user || {}).shop_permissions || {}).devices_permission === USER_PERMISSIONS.DENY ? (
              ''
            ) : (
              <Link to={ROUTES.CATEGORIES} style={{ textDecorationColor: 'transparent' }}>
                <div
                  className={`${styles.navItem} ${styles.mt - 4}`}
                  style={{
                    ...tabStyle,
                    ...(selectedTab === 'categories' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                  }}
                  onClick={() => {
                    handleSelectedTabChange('categories');
                  }}
                >
                  <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                    <CategoryIcon fontSize="small" className={styles.navBarIconColor} />
                  </span>
                  <span className={styles.title}>{t('Categories')}</span>
                </div>
              </Link>
            )}
            {shop && !ShopsHelper.isBasicPlan(shop) && (
              <>
                {((user || {}).shop_permissions || {}).devices_permission === USER_PERMISSIONS.DENY ? (
                  ''
                ) : (
                  <Link
                    to={ROUTES.SALES_PERSON}
                    style={{ textDecorationColor: 'transparent' }}
                    onClick={(e) => {
                      if (ShopsHelper.isFreePlan(shop)) {
                        e.preventDefault();
                        openUpgradeModal();
                      } else {
                        handleSelectedTabChange('salesperson');
                      }
                    }}
                  >
                    <div
                      className={`${styles.navItem} ${styles.mt - 4}`}
                      style={{
                        ...tabStyle,
                        ...(selectedTab === 'salesperson' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                      }}
                    >
                      <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                        <PersonIcon fontSize="small" className={styles.navBarIconColor} />
                      </span>
                      <span className={ShopsHelper.isFreePlan(shop) ? styles.buttonContainer : styles.title}>
                        <span className={styles.buttonText}>{t('Salespersons')}</span>
                        {ShopsHelper.isFreePlan(shop) && (
                          <Button
                            size="small"
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openUpgradeModal();
                            }}
                            className={styles.upgradeButton}
                          >
                            Upgrade
                          </Button>
                        )}
                      </span>
                    </div>
                  </Link>
                )}
              </>
            )}
            {((user || {}).shop_permissions || {}).devices_permission === USER_PERMISSIONS.DENY ? (
              ''
            ) : (
              <Link to={ROUTES.TERMINALS} style={{ textDecorationColor: 'transparent' }}>
                <div
                  className={`${styles.navItem} ${styles.mt - 4}`}
                  style={{
                    ...tabStyle,
                    ...(selectedTab === 'terminals' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                  }}
                  onClick={() => {
                    handleSelectedTabChange('terminals');
                  }}
                >
                  <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                    <DevicesIcon fontSize="small" className={styles.navBarIconColor} />
                  </span>
                  <span className={styles.title}>{t('Terminals')}</span>
                </div>
              </Link>
            )}

            {((user || {}).shop_permissions || {}).shop_permission === USER_PERMISSIONS.DENY ? (
              ''
            ) : (
              <Link to={ROUTES.WAREHOUSES} style={{ textDecorationColor: 'transparent' }}>
                <div
                  className={`${styles.navItem} ${styles.mt - 4}`}
                  style={{
                    ...tabStyle,
                    ...(selectedTab === 'warehouses' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                  }}
                  onClick={() => {
                    handleSelectedTabChange('warehouses');
                  }}
                >
                  <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                    <InventoryIcon fontSize="small" className={styles.navBarIconColor} />
                  </span>
                  <span className={styles.title}>{t('Warehouses')}</span>
                </div>
              </Link>
            )}
            {((user || {}).shop_permissions || {}).shop_permission === USER_PERMISSIONS.DENY ? (
              ''
            ) : (
              <Link to={ROUTES.SETTINGS} style={{ textDecorationColor: 'transparent' }}>
                <div
                  className={`${styles.navItem} ${styles.mt - 4}`}
                  style={{
                    ...tabStyle,
                    ...(selectedTab === 'settings' && { backgroundColor: '#5C62A8', borderRadius: '10px' }),
                  }}
                  onClick={() => {
                    handleSelectedTabChange('settings');
                  }}
                >
                  <span className={`${styles.iconHolder} ${styles.navIcon}`}>
                    <SettingsIcon fontSize="small" className={styles.navBarIconColor} />
                  </span>
                  <span className={styles.title}>{t('Settings')}</span>
                </div>
              </Link>
            )}
          </>
        )}
      </Grid>

      <PlanPrice open={showPlanPrice} onClose={handleClosePlanPrice} />
    </Grid>
  );
}
